var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.9938C7.44428 14.9938 6.99377 15.4443 6.99377 16C6.99377 16.5557 7.44428 17.0062 8 17.0062L8 16L8 14.9938ZM23.7115 16.7115C24.1045 16.3186 24.1045 15.6814 23.7115 15.2885L17.3079 8.88488C16.9149 8.49192 16.2778 8.49192 15.8849 8.88488C15.4919 9.27783 15.4919 9.91494 15.8849 10.3079L21.577 16L15.8849 21.6921C15.4919 22.0851 15.4919 22.7222 15.8849 23.1151C16.2778 23.5081 16.9149 23.5081 17.3079 23.1151L23.7115 16.7115ZM8 16L8 17.0062L23 17.0062L23 16L23 14.9938L8 14.9938L8 16Z",
    fill: "#1E171B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.a34da54d658234a3791b71add4a2140d.svg";
export { ForwardRef as ReactComponent };